// GetRemoteConfigDataWithTimeout.js
import { connect } from 'react-redux';

import GetRemoteConfigDataWithTimeout from '../component/GetRemoteConfigDataWithTimeout.jsx';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import {
  FLIX_DETAIL_FEED,
  SEARCH_FLIX_FEED,
  SEARCH_STORY_FEED,
  SEARCH_SWAGGER_ONLINE_FEED,
  SEARCH_SWAGGER_NEW_FEED,
} from '../RemoteConfigKeys.js';

const mapStateToProps = state => {
  return {
    flixDetailRecommendFlixCategory: getRemoteConfigData(
      state,
      FLIX_DETAIL_FEED
    ),
    searchRecommendFlixCategory: getRemoteConfigData(state, SEARCH_FLIX_FEED),
    searchRecommendStoryCategory: getRemoteConfigData(state, SEARCH_STORY_FEED),
    searchSwaggerOnlineFeed: getRemoteConfigData(
      state,
      SEARCH_SWAGGER_ONLINE_FEED
    ),
    searchSwaggerNewFeed: getRemoteConfigData(state, SEARCH_SWAGGER_NEW_FEED),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateRecommendFlixCategory: data =>
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['recommendFlixCategory'],
          data,
        },
      }),
    updateRecommendStoryCategory: data =>
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['recommendStoryCategory'],
          data,
        },
      }),
    updateSwaggerOnlineFeed: data =>
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['swaggerOnlineFeed'],
          data,
        },
      }),
    updateSwaggerNewFeed: data =>
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['swaggerNewFeed'],
          data,
        },
      }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GetRemoteConfigDataWithTimeout);
